module.exports = __webpack_public_path__ + "img/y_2015_hover.65f0ea3e.png";